<template>
  <div id="overlay" v-on:click="select">
    <div v-if="!is_ad" class="img" :style="{ backgroundImage: 'url(' + getImage + ')' }"></div>
    <div v-if="!is_ad" class="text" :title="overlay.name + '\n\n' + overlay.description">
      <h6>{{overlay.name}}</h6>
      <p>{{overlay.description | truncateText(190)}}</p>
    </div>
    <div v-if="resourceEnd && !is_ad" class="icon">
      <img :src="require('@/assets/icons/press.png')">
    </div>
    <div v-if="!is_ad" class="icon">
      <img :src="getImageEnd">
    </div>
    <img v-if="is_ad" ref="ad-img" class="ad-img">
  </div>
</template>

<script>
import Bus from '@/components/ControlBus'
import {StatsClickInteractivity} from '@/utils/constants'
const contentsService = require('@/services/contents.js')

export default {
  name: 'Overlay',
  props: ['overlay', 'image', 'resourceEnd'],
  data () {
    return {
      active: true,
      is_ad: false
    }
  },
  created: function () {
    // publi
    if (this.overlay.connect === 'ADV') { this.is_ad = true }
  },
  mounted () {
    // control keys
    Bus.$on('key-enter', this.keyEnter)
    // push auto
    if (this.overlay.connect === 'PUS' && this.overlay.is_auto) {
      contentsService.sendPush(this.overlay.id)

      if (this.$store.getters.platform === 'browser') {
        // this.$emit('onPush') // pause
        let win = window.open(this.overlay.url_push, '_blank')
        if (win) { win.focus() }
      }
    }

    // publi
    if (this.overlay.connect === 'ADV') {
      this.$refs['ad-img'].src = this.resourceEnd.file.media
    }
  },
  computed: {
    getImage: function () { if (this.overlay.image) { return this.overlay.image } else { return this.image } },
    getImageEnd: function () {
      if (this.resourceEnd && this.resourceEnd.type === 'TST') {
        return require('@/assets/icons/quiz.png')
      } else if (this.resourceEnd && this.resourceEnd.type === 'PLN') {
        return require('@/assets/icons/plain.png')
      } else if (this.resourceEnd && this.resourceEnd.type === 'VID') {
        return require('@/assets/icons/video.png')
      } else if (this.overlay.connect === 'ACR') {
        return require('@/assets/icons/acr.png')
      } else if (this.overlay.connect === 'PUS') {
        return require('@/assets/icons/push.png')
      }
    }
  },
  methods: {
    select () {
      if (this.active) {
        this.active = false

        const user = this.$store.getters.user ? this.$store.getters.user.id : false
        window.Countly.q.push(['add_event', {
          'key': StatsClickInteractivity,
          'segmentation': {
            'id': this.overlay.id,
            'name': this.overlay.name,
            'connect': this.overlay.connect,
            'resource_end': this.overlay.resource_end,
            'user': user
          }
        }])

        if (this.resourceEnd && this.overlay.connect !== 'ADV') {
          // ir a... video / plano / test
          this.$el.style.display = 'none'
          this.$emit('onSelect', { id: this.resourceEnd.id, time: this.overlay.second_file })
        } else if (this.overlay.connect === 'PUS' && !this.overlay.is_auto) {
          contentsService.sendPush(this.overlay.id)

          if (this.$store.getters.platform === 'browser') {
            // this.$emit('onPush') // play
            let win = window.open(this.overlay.url_push, '_blank')
            if (win) { win.focus() }
          }
        } else if (this.overlay.connect === 'EMA') {
          contentsService.sendEmail(this.overlay.id)
          this.$el.style.display = 'none'
        }
      }
    },
    keyEnter: function () { if (this.$el.style.display !== 'none') { this.select() } }
  },
  beforeDestroy: function () {
    Bus.$off('key-enter', this.keyEnter)
  }
}
</script>

<style lang="sass" scoped>
#overlay
  // display: none
  position: absolute
  right: 0rem
  bottom: 9vh
  width: 100vw
  // height: 15vh
  max-width: 100%
  cursor: pointer
  background-color: rgba(0, 0, 0, 0.5)
  // border: 2px solid red

  display: flex
  display: -webkit-flex
  flex-direction: row
  flex-wrap: nowrap
  justify-content: space-between
  align-items: center

  height: 10vw

  .img
    background-position: center center
    background-repeat: no-repeat
    background-size: cover
    width: 10vw
    height: 10vw

  .text
    padding: 1rem
    // width: 65%
    // height: 10vw
    flex: 1
    height: 100%
    color: #fff
    overflow: hidden
    user-select: none

    h6
      font-size: 1.1rem
      font-weight: bold
      margin: 0 0 5px 0
      padding: 0
      // white-space: nowrap
      // overflow: hidden
      // text-overflow: ellipsis

    p
      font-size: 1rem
      line-height: 1.2
      margin: 0
      padding: 0

  .icon
    padding: 1vw
    width: 9%
    // height: 10vw

    display: flex
    justify-content: space-between
    align-items: center

    img
      max-width: 100%
      height: auto

  .ad-img
    width: 100%
    height: auto

@media (min-width: 768px)
  #overlay
     width: 87.5vw

     .text h6
      font-size: 1.6rem

     .text p
      font-size: 1.3rem

// @media all and (orientation:portrait)
//   /* Style adjustments for portrait mode goes here */
//   #overlay
//     background-color: red
//     bottom: 9vh

// @media all and (orientation:landscape)
//   /* Style adjustments for landscape mode goes here */
//   #overlay
//     background-color: blue
//     bottom: 20vh

</style>



// WEBPACK FOOTER //
// src/components/Overlay.vue